// // @flow
// import { Component, OnInit } from '@angular/core';
// import { HttpClient } from '@angular/common/http';
// import { Router } from '@angular/router';
// import { AuthService } from '../../../components/auth/auth.service';
// import {Subscription} from 'rxjs';
// import Swal from 'sweetalert2';

// @Component({
//     selector: 'changepassword',
//     template: require('./changepassword.html'),
// })

// export class ChangePasswordComponent implements OnInit {
//     AuthService;
//     Router;

//     public changePassword: any;
//     busy: Subscription;

//     toast = Swal.mixin({
//         toast: true,
//         position: 'center',
//         showConfirmButton: false,
//         timer: 3000,
//         backdrop: `rgba(30, 30, 37, 0.4)`
//     });

//     static parameters = [AuthService, Router, HttpClient];
//     constructor(_AuthService_: AuthService, router: Router, private http: HttpClient) {
//         this.AuthService = _AuthService_;
//         this.Router = router;
//         this.http = http;
      
//     }
//     ngOnInit() {
//       //   console.log("Wellcome to Change Password");
//         this.changePassword = {};
//     }

//     goForChangePassword({ value, valid }) {
//         if (valid) {
//             if (this.changePassword.newPassword == this.changePassword.confirmPassword) {
//                 if (localStorage.getItem('user')) {
//                     let localStorageData = JSON.parse(localStorage.getItem('user'));
//                     let userId = localStorageData._id;
//                     this.busy = this.http.put('/api/users/' + userId + '/password', this.changePassword, {observe:'response'})
//                                     .subscribe(response => {
//                                         console.log(response);
//                                         if (response.status == 204) {
//                                             this.Router.navigate(['/login']);
//                                         }
//                                     })
//                 }
                
//             }
//             else {
//                 this.toastWarningMsg("Password Mismatch");
//             }
//         }
//     }

//     toastWarningMsg(msg) {
//         this.toast({
//             type: 'warning',
//             title: msg
//         });
//     }
// }


import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HotkeysService, Hotkey } from 'angular2-hotkeys';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '../../../components/auth/auth.service';
import { UtilityService } from '../../shared/services/Utility.service';
import Swal from 'sweetalert2';
import * as $ from 'jquery';
import { AppServiceService } from '../../main/services/product.service';
// @flow
interface User {
  oldPassword: string;
  newPassword: string;
  confirmPassword: string;
}

@Component({
  selector: 'changepassword',
  template: require('./changepassword.html'),
})
export class ChangePasswordComponent implements OnInit {
  user: User = {
    oldPassword: '',
    newPassword: '',
    confirmPassword: ''
  };
  errors = { other: undefined };
  message = '';
  submitted = false;
  AuthService;

  public unitInfo: any;
  public createdBy: any;

  public hotkeyList: Hotkey[];

  toast = Swal.mixin({
    toast: true,
    position: 'center',
    showConfirmButton: false,
    timer: 3000,
    backdrop: `rgba(30, 30, 37, 0.4)`
  });

  toastWarningMsg(options) {
    if (typeof (options) == "object") {
      this.toast({
        type: 'warning',
        showConfirmButton: options.confirm_btn,
        timer: options.timer,
        title: options.msg
      });
    } else {
      this.toast({
        type: 'warning',
        title: options
      });
    }
  }

  f_check_string(p_value) {
    if (p_value == undefined || p_value === '' || p_value === null || p_value !== p_value) {
      return "";
    } else {
      return p_value;
    }
  }
  strength: number = 0;
  strengthText: string = 'Weak';
  strengthColor: string = 'red';

  static parameters = [HttpClient, HotkeysService, Router, AuthService, UtilityService, AppServiceService];
  constructor(private http: HttpClient, private hotkeysService: HotkeysService, private router: Router, _AuthService_: AuthService, public utilityService: UtilityService, private appServiceService: AppServiceService) {

    this.http = http;
    this.hotkeysService = hotkeysService;
    this.AuthService = _AuthService_;
    this.utilityService = utilityService;
    this.appServiceService = appServiceService;
    this.unitInfo = JSON.parse(localStorage.getItem('permission'))[0];
    this.createdBy = this.unitInfo._id;

    setTimeout(() => {
      $("#oldPassword").focus();
    }, 200);

    var parent = this;
    $(document).ready(function () {

      $('form.formchangepassword').on('keydown', 'input, select, textarea, input[role=combobox]', function (e) {
        var self = $(this)
          , form = self.parents('form:eq(0)')
          , focusable
          , next;
        if (e.keyCode == 13) {
          focusable = form.find('a, select, button, textarea, input[role=combobox], input:not([readonly])').filter(':visible');
          next = focusable.eq(focusable.index(this) + 1);
          var res;
          var attr = $(this).attr('role');
          if (attr == 'combobox') {
            res = $(this).parents(".customNgSelect").map(function () {
              return this;
            }).get();
          }
          else {
            res = this;
          }
          if (next.length) {
            if ($(res).hasClass('ng-valid')) {
              next.focus().select();
            }
          }
          return false;
        }
      });


    });

  }

  ngOnInit() {
    setTimeout(() => {
        let localStorage = JSON.parse(window.localStorage.getItem('permission'));
        if(localStorage.length > 0){
            if(localStorage[0].AES_DEC){
                this.user.oldPassword = localStorage[0].AES_DEC;
                $('#newPassword').focus();
            }
        }
    }, 1000);
    this.initHotkeys();
  }

  initHotkeys() {
    this.hotkeyList = [];
    const f1 = new Hotkey('f1', (event: KeyboardEvent): boolean => {
      $('button[type=submit]#save').click();
      return false;
    }, ['INPUT', 'SELECT', 'TEXTAREA']);
    this.hotkeyList.push(f1);
    this.hotkeysService.add(f1);

    const f2 = new Hotkey('f2', (event: KeyboardEvent): boolean => {
      this.clearForm();
      return false;
    }, ['INPUT', 'SELECT', 'TEXTAREA']);
    this.hotkeyList.push(f2);
    this.hotkeysService.add(f2);

    const f3 = new Hotkey('f3', (event: KeyboardEvent): boolean => {
      $('button[type=button]#cancel').click();
      return false;
    }, ['INPUT', 'SELECT', 'TEXTAREA']);
    this.hotkeyList.push(f3);
    this.hotkeysService.add(f3);

  }

  clearForm() {

    Swal({
      title: 'Clear all fields?',
      text: "All the changes will be lost!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Confirm',
      customClass: 'swal-warning-custom'
    }).then(result => {
      if (result.value == true) {

        /* var focused = $(document.activeElement);
        $(focused).blur(); */

        this.user.oldPassword = "";  
        this.user.newPassword = "";
        this.user.confirmPassword = "";

        this.submitted = false;
        this.strength = 0;
        this.strengthText = 'Weak';
        this.isTypingPassword = false;
        this.message = '';
        setTimeout(() => {
          $('#oldPassword').focus().select();
        }, 200);
      }
      return true;
    });
  }

  goBack() {

    Swal({
      title: 'Close Change Password?',
      text: "All the changes will be lost!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Confirm',
      customClass: 'swal-warning-custom'
    }).then(result => {
      if (result.value) {
        // this.utilityService.getPreviousTab();
        this.router.navigateByUrl('/home');
      }
      return;
    });
  }


  changePassword(form) {

    this.message = '';

  //   console.log("changePassword");
    //if(form.invalid) return;
    var status = this.passwordValidate();
    if (!status) {
        setTimeout(() => { $("input[name=newPassword]").focus(); }, 100);
        return;
    };

    if (this.f_check_string(this.user.oldPassword).trim() == "") {
      this.toastWarningMsg("Enter the Old Password");
      $("#oldPassword").focus();
      return false;
    }
    if (this.f_check_string(this.user.newPassword).trim() == "") {
      // this.toastWarningMsg("Enter the New Password");
      $("#newPassword").focus();
      return false;
    }

    if (this.f_check_string(this.user.newPassword).trim().length < 8) {
      // this.toastWarningMsg("Password must be at least 8 characters.");
      $("#newPassword").focus();
      return false;
    }

    var specialCharPattern = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
    var uppercasePattern = /[A-Z]/;
    var numericPattern = /[0-9]/;
  
    if (this.f_check_string(this.user.newPassword.search(specialCharPattern) == -1)) {
        // this.toastWarningMsg('Password must have at least one special character!');
        setTimeout(() => {
            $('input[name=newPassword]').focus();
        }, 100);
        return false;
    }

    if (this.f_check_string(this.user.newPassword.search(uppercasePattern) == -1)) {
        // this.toastWarningMsg('Password must have at least one uppercase letter!');
        setTimeout(() => {
            $('input[name=newPassword]').focus();
        }, 100);
        return false;
    }

    if (this.f_check_string(this.user.newPassword.search(numericPattern) == -1)) {
        // this.toastWarningMsg('Password must have at least one numeric digit!');
        setTimeout(() => {
            $('input[name=newPassword]').focus();
        }, 100);
        return false;
    }

    if (this.f_check_string(this.user.confirmPassword).trim() == "") {
      this.toastWarningMsg("Enter the Confirm Password");
      $("#confirmPassword").focus();
      return false;
    }

    if (!(this.user.newPassword == this.user.confirmPassword)) {
      this.toastWarningMsg("New password and Confirm new password not match");
      $("#confirmPassword").focus();
      return false;
    }

    if (this.user.oldPassword.toLowerCase() == this.user.newPassword.toLowerCase()) {
        this.toast({ type: 'warning', title: 'Old Password Can Not be Same as Current Password' });
        $("#newPassword").focus();
        return;
    }

    this.submitted = true;

    /* return this.AuthService.changePassword(this.user.oldPassword, this.user.newPassword)
      .then(() => { //console.log("response : ", res);
          this.message = 'Password successfully changed.';
      })
      .catch(() => {
          // form.password.$setValidity('mongoose', false);
          this.errors.other = 'Incorrect password';
          this.message = 'aaaaaa';
      }); */

    return this.AuthService.changePassword(this.user.oldPassword, this.user.newPassword, (res) => { return res })
      .then((response) => {
        console.log("Change password api res::",response);

        if (response.flag == true) {
          // Roll_ID: 4
          let localStorage = JSON.parse(window.localStorage.getItem('permission'));
          console.log("localStorage::",localStorage);
          console.log("Role ID::",localStorage[0].Roll_ID);
          this.message = 'Password successfully changed';
          this.toastWarningMsg("Password successfully changed");
          setTimeout(() => {
            this.logout();
          }, 500);
        }
        else {
          this.message = '';
          this.toastWarningMsg("Old password are incorrect");
          $("#oldPassword").focus();
        }
      })
      .catch(() => {
        // form.password.$setValidity('mongoose', false);
        this.errors.other = 'Incorrect password';
        this.message = 'Error on change password';
      });
  };

  passwordValidate(){
    this.isTypingPassword = false;
    if(!this.user.newPassword){
        return;
    }
    if(this.user.newPassword.length < 8){
        // this.toastWarningMsg('Password should be minimum of 8 characters !');
        setTimeout(() => {
            $('input[name=newPassword]').focus();
        }, 100);
        return false;
    }
    var pass = this.user.newPassword;
    var specialCharPattern = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
    var uppercasePattern = /[A-Z]/;
    var numericPattern = /[0-9]/;

    if (this.f_check_string(pass.search(specialCharPattern) == -1)) {
        // this.toastWarningMsg('Password must have at least one special character!');
        setTimeout(() => {
            $('input[name=newPassword]').focus();
        }, 100);
        return false;
    }

    if (this.f_check_string(pass.search(uppercasePattern) == -1)) {
        // this.toastWarningMsg('Password must have at least one uppercase letter!');
        setTimeout(() => {
            $('input[name=newPassword]').focus();
        }, 100);
        return false;
    }

    if (this.f_check_string(pass.search(numericPattern) == -1)) {
        // this.toastWarningMsg('Password must have at least one numeric digit!');
        setTimeout(() => {
            $('input[name=newPassword]').focus();
        }, 100);
        return false;
    }
    return true;
};

isTypingPassword: boolean = false;
    passwordStrength(value: string) {
        this.isTypingPassword = value.length > 0;
        this.strength = this.utilityService.calculateStrength(this.user.newPassword);
    
        if (this.strength < 50) {
            this.strengthText = 'Weak';
            this.strengthColor = 'red';
        } else if (this.strength < 100) {  
            this.strengthText = 'Average';
            this.strengthColor = 'orange';
        } else {
            this.strengthText = 'Strong';
            this.strengthColor = 'green';
        }
    };

  movefocus(id){
          if(id == 1){
            if(!this.user.oldPassword){
              this.toastWarningMsg('Enter the Old Password');
              $('#oldPassword').focus().select();
              return;
            }else{
              $('#newPassword').focus().select();
            }
          }else if(id == 2){
              this.isTypingPassword = false;
              $('#confirmPassword').focus().select();
          }else if(id == 3){
              $('#save1').focus().select();
          }
      }


  per: any;
  logout() {
    // ERP-6635
    var per = JSON.parse(localStorage.getItem('permission'))[0];
    this.http.post('/api/users/RemoveLoggedInTime', { "UserId": per["_id"] })
      .subscribe(response => {
        return this.AuthService.logout().then(() => {
          this.router.navigateByUrl('/login');
          localStorage.clear();
          this.reset();
          this.appServiceService.getFooterDetails();
          this.appServiceService.footerDataSubject.next(null);
          this.appServiceService.OnDashboardDataLoad();
          setTimeout(() => {
            this.appServiceService.footerDataTable.subscribe(res => {
              this.per = res;
            });
          }, 600);
        });
      });
  };
  
    isAdmin: any;
    currentUser: any;
    private userObj: any;
    type: any;
    isLoggedIn: any;
    reset() {
        this.userObj = {};
        this.type = {};
        this.AuthService.isLoggedIn().then(is => {
            this.isLoggedIn = is;
        });
        this.AuthService.isAdmin().then(is => {
            this.isAdmin = is;
        });
        this.AuthService.getCurrentUser().then(user => {
            this.currentUser = user;
        });
        setTimeout(() => {
            if (localStorage.getItem('user') && localStorage.getItem('permission')) {
                this.userObj = JSON.parse(localStorage.getItem('user'));
                this.type = JSON.parse(localStorage.getItem('permission'))[0];
            }
        }, 1000);
    };

    switchAccount(){
        this.logout();        
    }
  revealPass(event, inputID, revealID) {
    // console.log('🚀 ~ event:', event)
    const password = document.querySelector('#' + inputID);
    const toggle = document.querySelector('#' + revealID);
    const type = password.getAttribute('type') === 'password' ? 'text' : 'password';
    password.setAttribute('type', type);
    toggle.classList.toggle('fa-eye-slash');
  }
}